export const SET_CREDENTIALS = "SET_CREDENTIALS"
export const SET_BUSINESS = "SET_BUSINESS"
export const SET_EMAIL = "SET_EMAIL"
export const SET_VENUE = "SET_VENUE"
export const SET_LAST_VENUE = "SET_LAST_VENUE"
export const SET_STOCK_LEVEL = "SET_STOCK_LEVEL"
export const SET_ORDERS = "SET_ORDERS"
export const ADD_ORDER = "ADD_ORDER"
export const ORDER_STATUS = "ORDER_STATUS"
export const ORDER_UPDATING = "ORDER_UPDATING"
export const SET_SERVICE = "SET_SERVICE"
export const SET_CONNECTED = "SET_CONNECTED"
export const LOGOUT = "LOGOUT"

function setCredentials(credentials) {
  return { type: SET_CREDENTIALS, credentials }
}

function setBusiness(business) {
  return { type: SET_BUSINESS, business }
}

function setEmail(email) {
  return { type: SET_EMAIL, email }
}

function setLastVenue(venue) {
  return { type: SET_LAST_VENUE, venue }
}

function setMyVenue(venue) {
  return { type: SET_VENUE, venue }
}

function setStockLevel(itemId, inStock) {
  return { type: SET_STOCK_LEVEL, itemId, inStock }
}

function setOrders(orders) {
  return { type: SET_ORDERS, orders }
}

function addOrder(order) {
  return { type: ADD_ORDER, order }
}

function updateOrderStatus(order, status) {
  return { type: ORDER_STATUS, order, status }
}

function setOrderUpdating(order, status) {
  return { type: ORDER_UPDATING, order, status }
}

function setService(service) {
  return { type: SET_SERVICE, service }
}

function logout(state) {
  return { type: LOGOUT, state }
}

function setConnected(connected) {
  return { type: SET_CONNECTED, connected }
}

export default {
  setCredentials,
  setBusiness,
  setEmail,
  setMyVenue,
  setLastVenue,
  setStockLevel,
  setOrders,
  addOrder,
  updateOrderStatus,
  setOrderUpdating,
  setService,
  logout,
  setConnected,
}
